import SideMenuMobile from "mpm-components/menu/SideMenuMobile";
import TopMenuMobile from "mpm-components/menu/TopMenuMobile";
import React from "react";
import { isMobile } from 'react-device-detect';
import Components from "../index";

function MainLayout(props) {
  return (
   isMobile ? <MobileLayout {...props} /> : <DesktopLayout {...props} />
  );
}

function DesktopLayout(props){
  return ( <>
    <Components.SideMenu />
    <div className="mpm-content-wrapper">
      <Components.TopMenu />
      <div className="mpm-content">{props.children}</div>
      <Components.Footer />
    </div>
  </>
  )
}
function MobileLayout(props) {
  const [bigMenu, setBigMenu] = React.useState(true)

  return (
    <div className="relative min-h-screen ">
      <TopMenuMobile bigMenu={bigMenu} handleMenuClick={() => setBigMenu(!bigMenu)}/>
      <div className={`sidebar pt-10 top-0  z-40 bg-blue-800 text-blue-100 w-64 space-y-6  fixed overflow-y-auto inset-y-0 left-0 transform ${bigMenu ? '-translate-x-full' : ''}   transition duration-200 ease-in-out`}>
        <SideMenuMobile hideSidebar={() => setBigMenu(true)}/>
      </div>
      <div className="body-content flex-1 h-screen" onClick={() => setBigMenu(true)}>
        <div className="p-2 pt-16 w-full h-full overflow-auto text-sm">
          {props.children}
        </div>
      </div>
  </div>
  );
}


export default MainLayout;
